var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2079 3.54949L16.4505 5.79104L14.2079 3.54949ZM15.6501 1.57476L9.58611 7.63871C9.27279 7.95159 9.05911 8.35023 8.97199 8.78437L8.41187 11.5882L11.2157 11.027C11.6498 10.9402 12.0479 10.7273 12.3613 10.4139L18.4253 4.34997C18.6075 4.16775 18.752 3.95142 18.8506 3.71333C18.9493 3.47525 19 3.22007 19 2.96237C19 2.70466 18.9493 2.44949 18.8506 2.2114C18.752 1.97332 18.6075 1.75699 18.4253 1.57476C18.243 1.39254 18.0267 1.24799 17.7886 1.14938C17.5505 1.05076 17.2954 1 17.0377 1C16.78 1 16.5248 1.05076 16.2867 1.14938C16.0486 1.24799 15.8323 1.39254 15.6501 1.57476V1.57476Z",
    stroke: "#00539A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8825 13.7058V16.8823C16.8825 17.4439 16.6594 17.9826 16.2623 18.3797C15.8651 18.7768 15.3265 18.9999 14.7648 18.9999H3.11767C2.55603 18.9999 2.01739 18.7768 1.62025 18.3797C1.22311 17.9826 1 17.4439 1 16.8823V5.2351C1 4.67346 1.22311 4.13482 1.62025 3.73768C2.01739 3.34054 2.55603 3.11743 3.11767 3.11743H6.29417",
    stroke: "#00539A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.81668bb4.svg";
export { ForwardRef as ReactComponent };